import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Popover } from '@mui/material';
// mocks_
import account from '../../../_mock/account';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  // {
  //   label: 'Home',
  //   icon: 'eva:home-fill',
  // },
  {
    label: 'Profile',
    icon: 'eva:person-fill',
  },
  {
    label: 'Settings',
    icon: 'eva:settings-2-fill',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleClose1 = () => {
    navigate('/login', { replace: true });
    localStorage.removeItem('token');
    localStorage.removeItem('userid')
    localStorage.removeItem('role')
    localStorage.removeItem('name')
    localStorage.removeItem('image');
    localStorage.removeItem("companyLogo");
    localStorage.removeItem("resource", "resource")
    localStorage.removeItem("hidedash", "hidedash");
    localStorage.removeItem("dash", "dash");
  }

  const Signat = () => {
    // alert("singnature")  
    // navigate('./Signature')
    navigate('./profile')
    handleClose();
  }

  const [isSquare, setIsSquare] = useState(true); 

  useEffect(() => {
    const checkImageShape = (src) => {
      const img = new Image();
      img.onload = () => {
        // Check aspect ratio of the image
        setIsSquare(img.width === img.height);
      };
      img.src = src;
    };

    if (companyLogo) {
      checkImageShape(companyLogo);
    }
  },
)

  const role = localStorage.getItem("role")
  const typeUser = localStorage.getItem("typeUser")
  const companyLogo = localStorage.getItem("companyLogo");
  // console.log("companyLogo", companyLogo)
  // const companyLogo = "https://foxstoragefoxearch.s3.ap-south-1.amazonaws.com/profile/olaKNVlKtYgkDCKYGUHLIMqZS.jpeg";

  return (
    <>
      <IconButton
        onClick={handleOpen}
        // sx={{
        //   p: 0, 
        //   ...(open && {
        //     '&:before': {
        //       zIndex: 1,
        //       content: "''",
        //       width: '100%',
        //       height: '100%',
        //       borderRadius: '50%',
        //       position: 'absolute',
        //       bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
        //     },
        //   }),
        // }}
        color={'default'}
        sx={{
          width: "auto",
          height: 38,
          ml: 1,
          mt: 0.1,
          mr:60,
          // backgroundColor: 'white',
          // borderRadius: '50%', 
          padding: 0, 
          '&:hover': {
            backgroundColor: 'white',
          },
        }}
      >
        {role === "superadmin" ? (
  <Avatar src={''} alt="photoURL" />
) : typeUser === "individual" ? (
  <img
 src="/assets/LogoInd.png"
  style={{
    
    width:"auto !important",
    height : 39,  
    objectFit: 'contain', 
    
  }}
  alt="photoURL"
/>
) : (

  companyLogo ? (

    <img
src={companyLogo || "photoURL"}
style={{
// borderRadius: role === 'superadmin' ? '50%' : 0, 
bgcolor: companyLogo || 'photoURL',
// width: companyLogo ? (isSquare ? 38 : 'auto') : "auto",
width:"auto !important",
height : 38,  
objectFit: companyLogo ? 'cover' : 'contain', 

}}
alt="photoURL"
/>
  ):(

<Avatar src={'/assets/logoFox.svg'} alt="photoURL" />
  )
        )}

      </IconButton>

      <Popover 
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Typography
 variant="body2"
  sx={{
    color: 'text.secondary',
    my: 1, px: 2.5,
    fontSize: "12px",
    fontWeight:"bold",
    // textAlign: 'left',
    // width: '100%', 
    // display: 'flex',
    // justifyContent: 'center', 
    // overflow: 'hidden', 
    textTransform: "capitalize", 
  }}
  noWrap
>
  { role !== "superadmin" ? localStorage.getItem('companyName') :''}
</Typography>

        <Box sx={{ px: 2.5 }}>
          <Typography variant="subtitle2" noWrap sx={{textTransform: "capitalize"}}>
            {localStorage.getItem('username')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {localStorage.getItem('email')}
          </Typography>
        </Box> 
        <Divider sx={{ borderStyle: 'dashed', mt:1 }} />

        {/* <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} >
              {option.label}
            </MenuItem>
          ))}
        </Stack> */}
        <Stack sx={{ p: 1 }}>


          <MenuItem onClick={Signat}>
            Settings
          </MenuItem>

          <MenuItem onClick={(e) => handleClose1(e)} sx={{}}>
            Logout
          </MenuItem>

        </Stack>

        {/* <Divider sx={{ borderStyle: 'dashed' }} /> */}


      </Popover>
    </>
  );
}
